import {cn} from 'platform/shared-tw';

import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface BrakeFluidProps {
  variant?: DiagramVariant;
  onClick?: () => void;
}

export function BrakeFluid(props: BrakeFluidProps) {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="absolute [pointer-events:none] cursor-pointer group"
      style={{bottom: 122, left: 232}}
      onClick={props.onClick}
    >
      <circle
        cx="13"
        cy="13"
        r="12"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></circle>
      <circle
        cx="13"
        cy="13"
        r="12"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M21 13L17 19.9282L8.99997 19.9282L4.99997 13L8.99997 6.0718L17 6.0718L21 13Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <circle
        cx="13"
        cy="13"
        r="4"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
    </svg>
  );
}
